import PinnedLayerComponent from '@wix/thunderbolt-elements/src/thunderbolt-core-components/PinnedLayer/viewer/PinnedLayer';


const PinnedLayer = {
  component: PinnedLayerComponent
};


export const components = {
  ['PinnedLayer']: PinnedLayer
};

